import React from 'react';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import BlockImage from '../BlockImage/BlockImage';

export interface ImageSerializerProps {
  value: { image: CloudinaryImageType; mobileImage?: CloudinaryImageType };
}

export const Image = ({ value: { image } }: ImageSerializerProps) => <BlockImage image={image} />;
